import { Header } from "../../../components/layout/header";
import { Main } from "../../../components/layout/main";
import { LogOut } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { useAuthStore } from "../../../stores/auth";
import { useNavigate, useLocation, Outlet } from "react-router-dom";

const Report: React.FC = () => {
    const { logout } = useAuthStore();

    const navigate = useNavigate();


    const isDetailPage = useLocation().pathname.includes('detail');
    return (
        <>
            <Header fixed className='flex justify-between w-[inherit]'>
                <div className="flex items-center justify-end w-[inherit]">
                    <Button variant="outline" size="icon" onClick={logout}>
                        <LogOut />
                    </Button>
                </div>
            </Header>
            <Main>
                <h4 className="text-xl font-semibold">
                    <span className="hover:underline cursor-pointer" onClick={() => navigate(-1)}>
                        Report
                    </span>
                    {isDetailPage ? " / detail" : ""}
                </h4>

                <div className="flex gap-4 mt-4 w-full flex-wrap">
                    <Outlet />
                </div>
            </Main>
        </>
    )
}

export default Report;